//     Prevent going to the /collections/all page when user clicks shop.
//     Instead expand the submenu
const shopItem = document.querySelector("a[href='/collections/all']");
shopItem.removeAttribute("href");
shopItem.classList.add("dm-custom__hover-pointer")
shopItem.onclick = (e) => {
  const parent = $(e.target.parentElement);
  parent.hasClass("mobile-nav--expanded") ? 
    parent.removeClass("mobile-nav--expanded") : 
  parent.addClass("mobile-nav--expanded")      	
}